module.exports = __webpack_public_path__ + "img/L2.c08ffd54.png";